import { render, staticRenderFns } from "./PatProfileAPage.vue?vue&type=template&id=bc07f0e4"
import script from "./PatProfileAPage.vue?vue&type=script&lang=js"
export * from "./PatProfileAPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports